"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "head" };
const _hoisted_2 = { class: "left-side" };
const _hoisted_3 = { class: "calendar-text tab" };
const _hoisted_4 = { class: "mr-4" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-down transform-gpu transition-transform text-xs",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "right-side" };
const _hoisted_8 = { class: "head-link" };
const _hoisted_9 = { class: "icon shop-icon" };
const vue_3 = require("vue");
const DropdownMenu_vue_1 = __importDefault(require("../Navigation/DropdownMenu.vue"));
const DropdownItem_vue_1 = __importDefault(require("../Navigation/DropdownItem.vue"));
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
const vue_datepicker_1 = __importDefault(require("@vuepic/vue-datepicker"));
require("@vuepic/vue-datepicker/dist/main.css");
const bookedAppointmentsStore_1 = require("../../../stores/backend/bookedAppointments/bookedAppointmentsStore");
const appointmentStore_1 = require("../../../stores/appointment/appointmentStore");
const date_fns_1 = require("date-fns");
const vue_router_1 = require("vue-router");
const i18n_1 = __importDefault(require("../../../common/i18n"));
const addDays_1 = __importDefault(require("date-fns/addDays"));
const i18n_2 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Head',
    setup(__props) {
        const currentLang = (0, vue_3.computed)(() => i18n_2.i18n.locale.value);
        const route = (0, vue_router_1.useRoute)();
        //console.log(route.name);
        const caretUp = (0, vue_3.ref)(false);
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        const bookedAppointmentsStore = (0, bookedAppointmentsStore_1.useBookedAppointmentsStore)();
        const freeAppointmentsStore = (0, appointmentStore_1.useAppointmentStore)();
        const handleMonthYear = ({ month, year }) => {
            if (route.name === "reservations_calendar_view" &&
                companyLocationStore.selectedLocation !== null) {
                getAppointmentsForMonth(year, month);
            }
        };
        (0, vue_3.watch)(() => [route.name], ([newRoute]) => {
            if (newRoute === "reservations_calendar_view" &&
                companyLocationStore.selectedLocation !== null) {
                handleMonthYear({
                    month: bookedAppointmentsStore.selectedDate.getMonth(),
                    year: bookedAppointmentsStore.selectedDate.getFullYear(),
                });
            }
        }, { immediate: true });
        const markers = (0, vue_3.ref)([]);
        async function getAppointmentsForMonth(year, month) {
            var _a, _b;
            await freeAppointmentsStore.getAppointments(year, month, (_b = (_a = companyLocationStore.selectedLocation) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null, -1);
            markers.value = [];
            Object.entries(freeAppointmentsStore.dates).forEach(([index, value]) => {
                //console.log(index);
                let color = "grey";
                let tooltip = i18n_1.default.trans("calendar_no_open", "Color meaning: don't have opening time in that day", "vuepic_calendar");
                if (value.status == "0") {
                    color = "green";
                    tooltip = i18n_1.default.trans("calendar_30min_free", "Color meaning: at least 30 min free in that day", "vuepic_calendar");
                }
                else if (value.status === "full") {
                    color = "red";
                    tooltip = i18n_1.default.trans("calendar_no_appointment", "Color meaning: no free appointments in that day", "vuepic_calendar");
                }
                markers.value.push({
                    date: (0, addDays_1.default)(new Date(year +
                        "-" +
                        String(month + 1).padStart(2, "0") +
                        "-" +
                        String(value.monthDay).padStart(2, "0")), 0),
                    type: "line",
                    color: color,
                    tooltip: [
                        {
                            text: tooltip,
                            color: color,
                        },
                    ],
                });
            });
        }
        const openDatepicker = () => {
            caretUp.value = true;
        };
        const closeDatepicker = () => {
            caretUp.value = false;
        };
        const filteredCompanies = (0, vue_3.computed)(() => {
            if (!companyLocationStore.selectedCompany)
                return companyLocationStore.companies;
            return companyLocationStore.companies.filter((company) => { var _a; return company.id !== ((_a = companyLocationStore.selectedCompany) === null || _a === void 0 ? void 0 : _a.id); });
        });
        const filteredLocations = (0, vue_3.computed)(() => {
            if (!companyLocationStore.selectedLocation)
                return companyLocationStore.locations;
            return companyLocationStore.locations.filter((location) => { var _a; return location.id !== ((_a = companyLocationStore.selectedLocation) === null || _a === void 0 ? void 0 : _a.id); });
        });
        return (_ctx, _cache) => {
            var _a, _b;
            const _component_font_awesome_icon = (0, vue_2.resolveComponent)("font-awesome-icon");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(DropdownMenu_vue_1.default, {
                        clickable: filteredCompanies.value.length >= 1,
                        "hide-caret": filteredCompanies.value.length < 1,
                        "button-text": ((_a = (0, vue_2.unref)(companyLocationStore).selectedCompany) === null || _a === void 0 ? void 0 : _a.name) +
                            ' - ' +
                            _ctx.$trans('backend_company', 'Company', 'head'),
                        searchable: true,
                        right: ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredCompanies.value, (company) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownItem_vue_1.default, {
                                    key: company.id,
                                    text: company.name,
                                    onClick: ($event) => ((0, vue_2.unref)(companyLocationStore).getLocationsByCompany(company))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(company.name) + " ", 1),
                                        (company.firstLocationName && company.name.toLowerCase() != company.firstLocationName.toLowerCase())
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                (0, vue_2.createTextVNode)(" - " + (0, vue_2.toDisplayString)(company.firstLocationName), 1)
                                            ], 64))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["text", "onClick"]));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["clickable", "hide-caret", "button-text"]),
                    (0, vue_2.createVNode)(DropdownMenu_vue_1.default, {
                        clickable: filteredLocations.value.length >= 1,
                        "hide-caret": filteredLocations.value.length < 1,
                        "button-text": ((_b = (0, vue_2.unref)(companyLocationStore).selectedLocation) === null || _b === void 0 ? void 0 : _b.name) +
                            ' - ' +
                            _ctx.$trans('backend_location', 'Location', 'head'),
                        right: ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredLocations.value, (location) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DropdownItem_vue_1.default, {
                                    key: location.id,
                                    onClick: ($event) => ((0, vue_2.unref)(companyLocationStore).selectLocation(location))
                                }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(location.name), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["onClick"]));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["clickable", "hide-caret", "button-text"]),
                    ((0, vue_2.unref)(route).name == 'reservations_calendar_view')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_datepicker_1.default), {
                            key: 0,
                            modelValue: (0, vue_2.unref)(bookedAppointmentsStore).selectedDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(bookedAppointmentsStore).selectedDate) = $event)),
                            class: "date-picker",
                            locale: currentLang.value,
                            "enable-time-picker": false,
                            "show-buttons": false,
                            "auto-apply": "",
                            clearable: false,
                            "close-on-scroll": "",
                            markers: markers.value,
                            onUpdateMonthYear: handleMonthYear,
                            onOpen: openDatepicker,
                            onClosed: closeDatepicker
                        }, {
                            trigger: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(date_fns_1.format)((0, vue_2.unref)(bookedAppointmentsStore).selectedDate, "yyyy.MM.dd")), 1),
                                    (0, vue_2.createElementVNode)("span", {
                                        class: (0, vue_2.normalizeClass)(["transition-transform ml-auto", { 'rotate-180': caretUp.value }])
                                    }, _hoisted_6, 2)
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue", "locale", "markers"]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("back_to_the_shop", "Back to the shop", "head")) + " ", 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                class: "circle",
                                icon: "fa-solid fa-circle-notch"
                            }),
                            (0, vue_2.createVNode)(_component_font_awesome_icon, {
                                class: "arrow-icon",
                                icon: "fa-solid fa-arrow-right"
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
